import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {animate, AnimationEvent, state, style, transition, trigger} from '@angular/animations';

const SLIDE_DURATION = 250;

@Component({
    selector: 'geo-kachel',
    templateUrl: './kachel.component.html',
    styleUrls: ['./kachel.component.scss'],
    animations: [
        trigger('slide', [
            state('visible', style({ left: '0', visibility: 'visible' })),
            state('slideToRight', style({ left: '100%' })),
            state('slideToLeft', style({ left: '-100%' })),
            state('lastPage', style({ left: '0', visibility: 'visible' })),
            transition('void => visible', animate(0)),
            transition('visible => slideToRight', animate(SLIDE_DURATION)),
            transition('slideToRight => visible', animate(SLIDE_DURATION)),
            transition('visible => slideToLeft', animate(SLIDE_DURATION)),
            transition('slideToLeft => visible', animate(SLIDE_DURATION)),
            transition('void => lastPage', animate(0))
        ])
    ],
    standalone: false
})
export class KachelComponent implements OnInit, OnChanges, AfterViewInit {

  public aktuellerSchritt = 1;
  public lock = false;

  public state = ['visible', 'slideToRight', 'slideToRight', 'slideToRight', 'slideToRight', 'slideToRight', 'slideToRight'];

  @Input() initSchritt = 1;
  @Input() letzterSchritt;
  @Input() ariaLabel = '';
  @Input() _id;
  @Output() pageChanged: EventEmitter<number> = new EventEmitter();

  @ViewChild('schritte')
  public schritteElem: ElementRef;

  ngOnChanges(model: SimpleChanges) {
    if (model.initSchritt) {
      this.wechsleSeite(this.initSchritt, true);
    }
  }

  ngOnInit() {
    if (!this.letzterSchritt) {
      throw new Error('Beim geo-kachel Element fehlt das Attribut letzterSchritt');
    }
  }

  ngAfterViewInit(): void {
    this.wechsleSeite(this.initSchritt);
    const arr = Array.from<HTMLElement>(this.schritteElem.nativeElement.children);
    arr.forEach((child) => {
      if (child.children.length === 0) {
        child.remove();
      }
    });
  }

  jumpTo(schritt, unlock = false) {
    this.wechsleSeite(schritt, unlock);
  }

  next(step = 1) {
    const anzahlKindElemente = this.schritteElem.nativeElement.children.length;
    if (this.aktuellerSchritt < anzahlKindElemente) {
      this.wechsleSeite(this.aktuellerSchritt + step);
    }
  }

  prev(step = 1) {
    if (this.aktuellerSchritt > 0) {
      this.wechsleSeite(this.aktuellerSchritt - step);
    }
  }

  private wechsleSeite(n: number, unlock = false) {
    if (!this.lock || unlock) {
      this.aktuellerSchritt = n;
      this.state.forEach((currentState, index) => {
        const i = index + 1;

        if (this.letzterSchritt === n) {
          this.state[index] = this.letzterSchritt === i ? 'lastPage' : 'void';
        } else if (n === i) {
          this.state[index] = 'visible';
        } else if (n > i) {
          this.state[index] = 'slideToLeft';
        } else {
          this.state[index] = 'slideToRight';
        }
      });
    }
  }

  animationDone(event: AnimationEvent) {
    if (['lastPage', 'visible'].includes(event.toState)) {
      this.pageChanged.emit(this.aktuellerSchritt);
      this.lock = false;
    }
  }

  animationStart(event: AnimationEvent) {
    if (['lastPage', 'visible'].includes(event.toState)) {
      this.lock = true;
    }
  }
}
